export default __webpack_public_path__ + "static/media/mail-at.28c6cf05.svg";